import React from "react";
import FlexWrapper from "../../../styles/shared/FlexWrapper";
import Partner from "../../../types/Partner";
import {
  createEmailsList,
  createPhoneNumbersList
} from "../../../utils/mapUtils";
import {
  TableContainer,
  TableRowItem,
  TableItemTitle,
  TableAddress,
  bgColor
} from "../styles/resultsStyles";
import WebsiteLink from "../../links/WebsiteLink";

interface ResultItemProps {
  data: Partner;
  includeBgColor: boolean;
}

const ResultItem = (props: ResultItemProps) => {
  const { data, includeBgColor } = props;
  const phoneNumbersList = createPhoneNumbersList(data.phones);
  const emailsList = createEmailsList(data.emails);

  return (
    <TableContainer backgroundColor={includeBgColor ? bgColor : "white"}>
      <FlexWrapper alignItems="center" wrap="wrap">
        <TableRowItem>
          <TableItemTitle>{data.name}</TableItemTitle>
        </TableRowItem>
        <TableRowItem>
          <TableAddress>
            {data.address},
            <br />
            {data.post_code} {data.city}
          </TableAddress>
        </TableRowItem>
        <TableRowItem>
          {phoneNumbersList && phoneNumbersList.map(phoneNumber => phoneNumber)}
          {emailsList && emailsList.map(email => email)}
          {data.website && <WebsiteLink website={data.website} />}
        </TableRowItem>
      </FlexWrapper>
    </TableContainer>
  );
};

export default ResultItem;
